import { APICurrentUserConfidentialFieldPermissions } from '@ardoq/api-types';
import { toStartDateName } from '@ardoq/date-range';

const canSeeConfidentialFieldByName = (
  confidentialFieldPermissions: APICurrentUserConfidentialFieldPermissions,
  fieldName: string,
  workspaceId: string
): boolean => {
  if (confidentialFieldPermissions.userCanSeeAllFields) {
    return true;
  }

  const {
    allConfidentialFieldNames,
    workspaceIdToConfidentialFieldsUserCanSee,
  } = confidentialFieldPermissions;

  const fieldsUserCanSee =
    workspaceIdToConfidentialFieldsUserCanSee[workspaceId];

  // Direct match
  if (allConfidentialFieldNames.includes(fieldName)) {
    if (!fieldsUserCanSee) {
      return false;
    }
    return fieldsUserCanSee.includes(fieldName);
  }

  // DateRange format fallback
  const startName = toStartDateName(fieldName);
  if (!allConfidentialFieldNames.includes(startName)) {
    return true;
  }

  if (!fieldsUserCanSee) {
    return false; // No exception configured for this workspace
  }
  return fieldsUserCanSee.includes(startName);
};

/**
 * Get a list of confidential fields in a specific workspace that the user cannot see.
 */
const fieldsInWorkspaceUserCannotSee = (
  confidentialFieldPermissions: APICurrentUserConfidentialFieldPermissions,
  workspaceId: string
): string[] => {
  if (confidentialFieldPermissions.userCanSeeAllFields) {
    return [];
  }

  const {
    allConfidentialFieldNames,
    workspaceIdToConfidentialFieldsUserCanSee,
  } = confidentialFieldPermissions;

  const fieldsUserCanSee =
    workspaceIdToConfidentialFieldsUserCanSee[workspaceId] || [];

  return allConfidentialFieldNames.filter(
    fieldName => !fieldsUserCanSee.includes(fieldName)
  );
};

export const confidentialFieldPermissionsOperations = {
  canSeeConfidentialFieldByName,
  fieldsInWorkspaceUserCannotSee,
};
